var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeaderboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5098 0H16.9504C16.5136 0 16.2948 0.528 16.6038 0.836978L18.0203 2.25353L9.75321 10.5206L6.85825 7.62569L6.08239 6.84982C5.81986 6.58729 5.39428 6.58729 5.13174 6.84982L0.1969 11.7844C-0.0656333 12.047 -0.0656333 12.4725 0.1969 12.7351L0.972767 13.5109C1.2353 13.7735 1.66088 13.7735 1.92341 13.5109L5.60694 9.8274L9.27214 13.4926C9.53468 13.7551 9.96025 13.7551 10.2228 13.4926L10.6173 13.0981C10.6376 13.0819 10.6589 13.0675 10.6777 13.0487L19.7466 3.9798L21.1631 5.39636C21.4721 5.70533 22.0001 5.48656 22.0001 5.04973V0.490356C22.0001 0.219511 21.7806 0 21.5098 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.043 9.24V21.3278C16.043 21.6991 16.3439 22 16.7152 22H18.8619C19.2332 22 19.5341 21.6991 19.5341 21.3278V5.74884L16.043 9.24Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5176 13.7651V21.3278C11.5176 21.6991 11.8185 22 12.1898 22H14.3365C14.7078 22 15.0087 21.6991 15.0087 21.3278V10.274L11.5176 13.7651Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74781 14.7896C9.27432 14.7896 8.82943 14.6053 8.49454 14.2704L6.99219 12.7683V21.3278C6.99219 21.6991 7.2931 22 7.66441 22H9.81112C10.1824 22 10.4833 21.6991 10.4833 21.3278V14.6285C10.2553 14.7329 10.0062 14.7896 9.74781 14.7896Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60669 11.3831L2.70122 14.2885C2.62837 14.3614 2.54942 14.4259 2.4668 14.4841V21.3278C2.4668 21.6991 2.76771 22 3.13902 22H5.28573C5.65704 22 5.95795 21.6991 5.95795 21.3278V11.7343L5.60669 11.3831Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/leaderboard.67d846d74849d89582f70f495d1a9d59.svg";
export { ForwardRef as ReactComponent };